export default __webpack_public_path__ + "static/media/clip_icon.8bc61ee2.svg";